import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Customers_Object} state
 *  @property {object} model
 *  @property {Customers_Properties} model.properties
 *  @property {Customers_Is} model.is
 *  @property {Customers_Has} model.has
 */
export default class CustomerAddObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Customers._name);
		// noinspection JSPrimitiveTypeWrapperUsage
		this.model.properties.ethnicity_hispanic.required = false;

		this.afterLegalEntitySave = this.setNewObject('legal_entity', 'legal_entities');
	}

	/**
	 * @param prevProps
	 * @param {Customers_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Customers_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name_first + " " + object.name_last);
		}
	}

	//Note: Doesn't need a form() function. Only ever used in a modal
	render() {
		/** @type {Customers_Properties} properties */
		let properties = this.model.properties;
		/** @type {Customers_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-md"}>
							<h4 className="section-title">Customer Information</h4>
							<Parts.CustomerName
								object={object}
								properties={properties}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
							/>

							<h4 className="section-title">Contact Information</h4>
							<div className="form-group">
								<Framework.Elements.PhoneNumber
									property={properties.phone}
									value={object.phone}
									error={object.phone_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.EmailAddress
									property={properties.email}
									value={object.email}
									error={object.email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={"col-md"}>
							<h4 className="section-title">Address</h4>
							<Parts.Address
								object={object}
								properties={properties}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
							/>

							<h4 className="section-title">Trust / Legal Entity Information</h4>
							<Parts.TransactionLegalEntity
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								history={this.props.history}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterLegalEntitySave={this.afterLegalEntitySave}
							/>
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
